const QyMessageTemplate = {
    path: 'qyMessageTemplate',
    component: resolve => require(['@/pages/admin/message/qyMessageTemplate/list.vue'], resolve)
}

export default QyMessageTemplate